/* ============================================================
   Potzillas · Facets enhancement (layer na Dawn)
   1) Barva  -> barevné puntíky podle názvu
   2) číselné filtry (Průměr/Výška/Šířka) -> double-range slider + Od/Do
      (facets.liquid je renderuje kompaktně: jen skryté checkboxy v [data-pz-range-values],
       slider nad nimi zaškrtává hodnoty v rozsahu a Dawn je odešle jako dřív)
   3) "8.0"  -> "8 cm"
   Funguje na desktopu i v mobilním draweru; po AJAX přefiltrování se znovu aplikuje.
   ============================================================ */
(function () {
  if (window.__pzFacetsInit) return;
  window.__pzFacetsInit = true;

  // název barvy -> CSS background (hex / gradient pro kovové a vícebarevnou)
  var COLORS = {
    'antracit': '#3b4145',
    'béžová': '#d9c8ac',
    'bílá': '#ffffff',
    'bronz': 'linear-gradient(135deg, #cda05d, #8a6a3b)',
    'černá': '#141414',
    'červená': '#c0392b',
    'hnědá': '#6f4a2f',
    'měděná': 'linear-gradient(135deg, #d98a5b, #a85a2e)',
    'modrá': '#2f5aa0',
    'oranžová': '#e87b2c',
    'růžová': '#e8a0b6',
    'šedá': '#9aa0a3',
    'stříbrná': 'linear-gradient(135deg, #e2e4e6, #aeb2b5)',
    'vícebarevná': 'conic-gradient(#e23b3b, #e8a93b, #3ca85a, #2f7fd1, #9b51e0, #e23b3b)',
    'zelená': '#4a7a46',
    'zlatá': 'linear-gradient(135deg, #e6c558, #b9952f)',
    'žlutá': '#e8c83a'
  };
  var BORDERED = { 'bílá': 1, 'béžová': 1, 'stříbrná': 1 };

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function fmt(n) {
    var r = Math.round(n * 10) / 10;
    return (r % 1 === 0) ? String(r) : String(r).replace('.', ',');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* --- 1) barevné puntíky --- */
  function enhanceSwatches() {
    document.querySelectorAll('.facet-checkbox__text-label').forEach(function (el) {
      if (el.querySelector('.pz-swatch')) return;
      var key = norm(el.textContent);
      var bg = COLORS[key];
      if (!bg) return;
      var dot = document.createElement('span');
      dot.className = 'pz-swatch' + (BORDERED[key] ? ' pz-swatch--bordered' : '');
      if (bg.indexOf('gradient') > -1) dot.style.backgroundImage = bg;
      else dot.style.background = bg;
      el.insertBefore(dot, el.firstChild);
    });
  }

  /* --- 3) "8.0" -> "8 cm" (i pro číselné filtry, které nemají slider) --- */
  function formatNumericLabels() {
    document.querySelectorAll('.facet-checkbox__text-label').forEach(function (el) {
      var t = el.textContent.trim();
      if (/^\d+(?:[.,]\d+)?$/.test(t)) {
        el.textContent = fmt(parseFloat(t.replace(',', '.'))) + ' cm';
      }
    });
  }

  /* --- 2) double-range slider u číselných filtrů --- */
  function enhanceRanges() {
    document.querySelectorAll('.js-filter').forEach(function (group) {
      var boxes = [].slice.call(group.querySelectorAll('input[type="checkbox"]'));
      if (boxes.length < 4) return;
      var items = [];
      for (var i = 0; i < boxes.length; i++) {
        var n = parseFloat(String(boxes[i].value).replace(',', '.'));
        if (isNaN(n)) return; // nečíselný filtr -> nech checkboxy
        items.push({ box: boxes[i], n: n });
      }
      items.sort(function (a, b) { return a.n - b.n; });
      // Vždy postav ČERSTVÝ slider navázaný na AKTUÁLNÍ checkboxy.
      // (Dawn po i částečném překreslení vrátí viditelný seznam; starý slider
      //  by ukazoval na zastaralé checkboxy a seznam by zůstal vidět.)
      var old = group.querySelector('[data-pz-range]');
      if (old && old.parentNode) old.parentNode.removeChild(old);
      buildSlider(group, items);
    });
  }

  function buildSlider(group, items) {
    // kompaktní obal z facets.liquid; plný seznam (starší HTML z cache, filtr s obrázky) skryjeme jako dřív
    var lists = group.querySelectorAll('[data-pz-range-values], .facets__list--vertical, .mobile-facets__list, .facets__list');
    var showMore = group.querySelector('show-more-button');
    var nums = items.map(function (x) { return x.n; });
    var N = nums.length;

    var checkedIdx = [];
    items.forEach(function (x, i) { if (x.box.checked) checkedIdx.push(i); });
    var lo = checkedIdx.length ? Math.min.apply(null, checkedIdx) : 0;
    var hi = checkedIdx.length ? Math.max.apply(null, checkedIdx) : N - 1;

    var wrap = document.createElement('div');
    wrap.className = 'pz-range';
    wrap.setAttribute('data-pz-range', '');
    wrap.innerHTML =
      '<div class="pz-range__inputs">' +
        '<span class="pz-range__field"><input type="text" inputmode="decimal" data-pz-min aria-label="Od"><span class="pz-range__unit">cm</span></span>' +
        '<span class="pz-range__sep">–</span>' +
        '<span class="pz-range__field"><input type="text" inputmode="decimal" data-pz-max aria-label="Do"><span class="pz-range__unit">cm</span></span>' +
      '</div>' +
      '<div class="pz-range__slider">' +
        '<input type="range" min="0" max="' + (N - 1) + '" step="1" data-pz-thumb-min aria-label="Od">' +
        '<input type="range" min="0" max="' + (N - 1) + '" step="1" data-pz-thumb-max aria-label="Do">' +
      '</div>';

    group.classList.add('pz-has-range');
    for (var li = 0; li < lists.length; li++) lists[li].style.display = 'none';
    if (showMore) showMore.style.display = 'none';
    var anchor = lists[0];
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    else group.appendChild(wrap);

    var tMin = wrap.querySelector('[data-pz-thumb-min]');
    var tMax = wrap.querySelector('[data-pz-thumb-max]');
    var fMin = wrap.querySelector('[data-pz-min]');
    var fMax = wrap.querySelector('[data-pz-max]');
    var slider = wrap.querySelector('.pz-range__slider');
    tMin.value = lo;
    tMax.value = hi;

    function paint() {
      var a = Math.min(+tMin.value, +tMax.value);
      var b = Math.max(+tMin.value, +tMax.value);
      fMin.value = fmt(nums[a]);
      fMax.value = fmt(nums[b]);
      var loF = N > 1 ? a / (N - 1) : 0;
      var hiF = N > 1 ? b / (N - 1) : 1;
      var s = hiF - loF;
      var pos = s >= 1 ? 0 : (loF / (1 - s)) * 100;
      slider.style.setProperty('--pz-fill-size', (s * 100) + '%');
      slider.style.setProperty('--pz-fill-pos', pos + '%');
    }

    function commit() {
      var a = Math.min(+tMin.value, +tMax.value);
      var b = Math.max(+tMin.value, +tMax.value);
      var full = (a === 0 && b === N - 1);
      items.forEach(function (x, i) { x.box.checked = !full && i >= a && i <= b; });
      paint();
      // Odeslat až po doběhnutí aktuální úlohy. Dawn při re-renderu odstraní i zaměřené
      // pole Od/Do a Chrome na něm ještě vyvolá 'change' → commit() starého slideru,
      // jehož checkbox je v tu chvíli ještě v DOM. Po re-renderu už není a Dawnův odložený
      // submit by spadl na closest('form') === null → odpojený checkbox neodesíláme.
      var box = items[0].box;
      setTimeout(function () {
        if (box.isConnected) box.dispatchEvent(new Event('input', { bubbles: true }));
      }, 0);
    }

    // DŮLEŽITÉ: 'input' z vlastních ovladačů zastavíme, ať Dawn neudělá
    // auto-submit (debounce 800 ms) se zastaralým stavem checkboxů.
    // Filtr se aplikuje JEN přes commit() (dispatch 'input' na skrytém checkboxu).
    tMin.addEventListener('input', function (e) { e.stopPropagation(); paint(); });
    tMax.addEventListener('input', function (e) { e.stopPropagation(); paint(); });
    tMin.addEventListener('change', function (e) { e.stopPropagation(); commit(); });
    tMax.addEventListener('change', function (e) { e.stopPropagation(); commit(); });

    function nearest(v) {
      var best = 0, bd = Infinity;
      for (var i = 0; i < N; i++) {
        var d = Math.abs(nums[i] - v);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    function bindField(field, thumb) {
      var t;
      function apply() {
        var v = parseFloat(field.value.replace(',', '.'));
        if (isNaN(v)) { paint(); return; }
        thumb.value = nearest(v);
        paint();
        commit();
      }
      // psaní neodesílá filtr přes Dawn; aplikuje se po pauze, nebo hned při blur/Enter
      field.addEventListener('input', function (e) {
        e.stopPropagation();
        clearTimeout(t);
        t = setTimeout(apply, 800);
      });
      field.addEventListener('change', function (e) {
        e.stopPropagation();
        clearTimeout(t);
        apply();
      });
      field.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); clearTimeout(t); apply(); }
      });
    }
    bindField(fMin, tMin);
    bindField(fMax, tMax);

    paint();
  }

  /* --- skryj číselné pilulky (rozsah ukazuje slider) ---
     filtry se sliderem mají z facets.liquid jen jednu pilulku [data-pz-range-pill] skrytou v CSS;
     tady zbývají číselné pilulky filtrů bez slideru (např. ≤ 3 hodnoty) */
  function hideNumericPills() {
    document.querySelectorAll('.active-facets__button').forEach(function (a) {
      var inner = a.querySelector('.active-facets__button-inner') || a;
      var clone = inner.cloneNode(true);
      clone.querySelectorAll('.visually-hidden, .svg-wrapper, svg').forEach(function (n) { n.remove(); });
      var t = clone.textContent.replace(/\s+/g, ' ').trim();
      if (/:\s*\d+(?:[.,]\d+)?$/.test(t)) {
        var fr = a.closest('facet-remove') || a;
        fr.style.display = 'none';
      }
    });
  }

  /* --- označ aktivní filtr (zvýraznění nadpisu, desktop i mobil) --- */
  function groupActive(group) {
    if (group.querySelector('input[type="checkbox"]:checked')) return true;
    var pin = group.querySelectorAll('price-range input, .facets__price input');
    for (var i = 0; i < pin.length; i++) {
      if (pin[i].value && pin[i].value.trim() !== '') return true;
    }
    return false;
  }
  function markActive() {
    document.querySelectorAll('.js-filter').forEach(function (g) {
      g.classList.toggle('pz-active', groupActive(g));
    });
  }

  var obs;

  function connect() {
    document.querySelectorAll('facet-filters-form, .active-facets').forEach(function (r) {
      obs.observe(r, { childList: true, subtree: true });
    });
  }

  function enhanceAll() {
    if (obs) obs.disconnect();
    try {
      enhanceRanges();
      formatNumericLabels();
      enhanceSwatches();
      hideNumericPills();
      markActive();
    } catch (e) { /* no-op */ }
    if (obs) connect();
  }

  var debEnhance = debounce(enhanceAll, 80);

  function init() {
    if (!document.querySelector('facet-filters-form')) return;
    obs = new MutationObserver(debEnhance);
    enhanceAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // theme editor vymění celou sekci → observer by hlídal staré prvky; napoj znovu a postav slidery
  document.addEventListener('shopify:section:load', function () {
    if (obs) enhanceAll();
    else init();
  });
})();

/* ============================================================
   Potzillas · Mobilní filtr drawer — oprava chování
   ------------------------------------------------------------
   1) Dawn volá po každém AJAX přefiltrování menu-drawer.bindEvents()
      znovu (facets.js → renderAdditionalElements), ale staré listenery
      neodebírá. Na prvcích, které re-render přežijí (hlavní summary,
      hlavní footer), se tak handlery násobí s každým klikem na filtr →
      closeSubmenu / trapFocus se pouští několikrát za sebou a drawer
      začne „bláznit". Handler proto pouštíme jen jednou za událost.
   2) Otevřená smí být jen jedna skupina — submenu jsou pozicovaná
      absolutně přes sebe, dvě otevřené se překrývají (rozsypaný nadpis
      se šipkou zpět uprostřed seznamu, dvakrát „Použít").
   3) Uvízlý stav: když se .menu-opening přidá k už zavřenému <details>,
      rodič zůstane s .submenu-open (visibility:hidden) a v draweru
      nejde na nic kliknout. Stav po každém kliku srovnáme.
   ============================================================ */
(function () {
  if (window.__pzFacetsDrawerInit) return;
  window.__pzFacetsDrawerInit = true;

  var Ctor = window.customElements && customElements.get('menu-drawer');
  if (Ctor && Ctor.prototype) {
    // stejný výběr buttonů jako Dawn v bindEvents()
    var BTNS =
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)';

    // (a) pojistka: kdyby na prvku i tak skončilo víc listenerů, tělo pustíme jen raz
    ['onSummaryClick', 'onCloseButtonClick'].forEach(function (name) {
      var orig = Ctor.prototype[name];
      if (typeof orig !== 'function' || orig.__pzOnce) return;
      var key = '__pzRan_' + name;
      function once(event) {
        if (event) {
          if (event[key]) return;
          event[key] = true;
        }
        return orig.call(this, event);
      }
      once.__pzOnce = true;
      Ctor.prototype[name] = once;
    });

    // (b) příčina: bindEvents() navazuje znovu i na prvky, které listener už mají
    if (!Ctor.prototype.bindEvents.__pzDedup) {
      var dedup = function () {
        var self = this;
        this.querySelectorAll('summary').forEach(function (el) {
          if (el.__pzBoundSummary) return;
          el.__pzBoundSummary = true;
          el.addEventListener('click', self.onSummaryClick.bind(self));
        });
        this.querySelectorAll(BTNS).forEach(function (el) {
          if (el.__pzBoundButton) return;
          el.__pzBoundButton = true;
          el.addEventListener('click', self.onCloseButtonClick.bind(self));
        });
      };
      dedup.__pzDedup = true;
      Ctor.prototype.bindEvents = dedup;
    }

    // Prvky, které stihl navázat konstruktor, označ jako hotové — jinak by jim
    // první re-render přidal druhý listener. Značíme jen upgradované drawery,
    // aby se při obráceném pořadí skriptů nestalo, že nenavážeme vůbec nic.
    document.querySelectorAll('menu-drawer').forEach(function (drawer) {
      if (!(drawer instanceof Ctor)) return;
      drawer.querySelectorAll('summary').forEach(function (el) {
        el.__pzBoundSummary = true;
      });
      drawer.querySelectorAll(BTNS).forEach(function (el) {
        el.__pzBoundButton = true;
      });
    });
  }

  // Srovnej stav: max. jedno otevřené submenu a .submenu-open podle skutečnosti.
  function reconcile() {
    document.querySelectorAll('.mobile-facets__main.has-submenu').forEach(function (main) {
      var current = null;
      main.querySelectorAll('details.mobile-facets__details[open].menu-opening').forEach(function (d) {
        if (current) closeGroup(d);
        else current = d;
      });
      main.classList.toggle('submenu-open', !!current);
    });
  }

  function closeGroup(details) {
    details.classList.remove('menu-opening');
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest('.mobile-facets__wrapper')) return;

      var summary = target.closest('.mobile-facets__summary');
      var details = summary ? summary.closest('details.mobile-facets__details') : null;

      if (details) {
        if (details.hasAttribute('open')) {
          // Druhý tap na už otevřenou skupinu by <details> nativně zavřel,
          // ale Dawn 100 ms po kliknutí zpátky přidá .menu-opening →
          // rodič zůstane skrytý a drawer je „mrtvý". Necháme otevřeno.
          event.preventDefault();
        } else {
          var main = details.closest('.mobile-facets__main');
          if (main) {
            main.querySelectorAll('details.mobile-facets__details[open]').forEach(function (other) {
              if (other !== details) closeGroup(other);
            });
          }
          // nová skupina vždy od začátku seznamu
          var list = details.querySelector('.mobile-facets__list');
          if (list) list.scrollTop = 0;
        }
      }

      // až po Dawnově setTimeout(…, 100) v onSummaryClick
      setTimeout(reconcile, 180);
    },
    true
  );
})();
